"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import CardDataItem from "@/views/costItems/components/CardDataItem.vue";
import DatasItems from "@/views/costItems/components/DatasItems.vue";
import BindVd from "./dialog/BindVd.vue";
const _gridController = new GridController(new APIDataSource(`api://base.auth/api/v7/vd_cards_bypage`));
let VDCardItem = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = _gridController;
    this.card = 0;
    this.cardOptions = [
      {
        label: this.$t("vdcarditem.all"),
        value: null
      },
      {
        label: this.$t("vdcarditem.available"),
        value: 0
      },
      {
        label: this.$t("vdcarditem.used"),
        value: 1
      },
      {
        label: this.$t("vdcarditem.expired"),
        value: 3
      }
    ];
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.filter = `status==0`;
      this.gridController.pagePosition = "dialog";
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  cardSearch() {
    return __async(this, null, function* () {
      if (this.card === null) {
        this.gridController.query.filter = null;
      }
      if (this.card !== null) {
        this.gridController.query.filter = `status==${this.card}`;
      }
      yield this.gridController.search();
    });
  }
  refreshCard() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  bindVD() {
    this._bind_vd.open();
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
};
__decorateClass([
  Ref("bind_vd")
], VDCardItem.prototype, "_bind_vd", 2);
VDCardItem = __decorateClass([
  Component({
    components: {
      DatasItems,
      CardDataItem,
      UiGrid,
      BindVd
    }
  })
], VDCardItem);
export {
  VDCardItem as default
};
